export const LINKEDIN_COMPANY_URL = 'https://www.linkedin.com/company/leagora/';
